import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.string.includes";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import addRewardItem from './component/addRewardItem.vue';
import uploadImagetow from '@/components/uploadImagetow';
import addWinner from './component/addWinner.vue';
export default {
  name: "winnerList",
  components: {
    addWinner: addWinner,
    addRewardItem: addRewardItem
  },
  props: ['eventId', 'eventStatus'],
  data: function data() {
    return {
      paramsData: {
        // page: 1,
        // page_size: 10,
        start_date: '',
        end_date: '',
        designated: ''
      },
      tableData: [],
      total: 0,
      delIds: [],
      chooseList: [{
        label: '排除内定',
        value: true
      }],
      value2: []
    };
  },
  created: function created() {
    this.getList(1);
  },
  methods: {
    handleSelectionChange: function handleSelectionChange(e) {
      this.delIds = e;
    },
    getRewardColor: function getRewardColor(rewardName) {
      if (!rewardName) return ''; // 没有背景颜色

      if (rewardName.includes('一等奖')) {
        return '#F56C6C';
      }

      if (rewardName.includes('二等奖')) {
        return '#409EFF';
      }

      if (rewardName.includes('三等奖')) {
        return '#909399';
      }

      return '';
    },
    datechange: function datechange() {
      if (this.value2 && this.value2.length > 0) {
        this.paramsData.start_date = this.value2[0];
        this.paramsData.end_date = this.value2[1];
      } else {
        this.paramsData.start_date = '';
        this.paramsData.end_date = '';
      }
    },
    getList: function getList(page) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // this.paramsData.page = page;
                _this.$api.eventAwardList(_objectSpread(_objectSpread({}, _this.paramsData), {}, {
                  event_id: _this.eventId
                })).then(function (res) {
                  if (res.code == 200) {
                    var data = res.data;
                    data.forEach(function (item) {
                      item.student_name = item.student.name;

                      if (item.final_format_time != '0') {
                        item.final_duration = item.final_format_time;
                      } else {
                        item.final_duration = _this.$utils.formatDuration(item.final_duration);
                      }
                    });
                    _this.tableData = data;
                    console.log("this.tableData", _this.tableData);
                    _this.total = res.data.total;
                  }
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    del: function del(dateList) {
      var _this2 = this;

      this.$confirm("\u6B64\u64CD\u4F5C\u5C06\u5220\u9664\u8BE5\u83B7\u5956\u8BB0\u5F55, \u662F\u5426\u7EE7\u7EED?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var ids;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                ids = dateList.map(function (item) {
                  return item.id;
                });

                _this2.$api.eventAwardDelete({
                  ids: ids,
                  event_id: _this2.eventId
                }).then(function (res) {
                  if (res.code == 200) {
                    _this2.$message.success("删除成功!");

                    _this2.getList(_this2.paramsData.page);
                  } else {
                    _this2.$message.error(res.msg);
                  }
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    },
    exportDataFn: function exportDataFn() {
      var _this3 = this;

      this.$confirm("\u8BF7\u4E0A\u4F20\u7B26\u5408\u5927\u8D5B\u5B98\u65B9\u683C\u5F0F\u7684\u6587\u6863", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.$refs.addWinner.init();

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      })));
    }
  }
};